/**
 * React Query hooks for admin infrastructure visualization.
 */

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  adminGetInfrastructure,
  adminRefreshInfrastructure,
  type InfrastructureData,
} from "../services/naraDoor";

const QUERY_KEY = ["adminInfrastructure"];

export function useAdminInfrastructure() {
  return useQuery<InfrastructureData>({
    queryKey: QUERY_KEY,
    queryFn: () => adminGetInfrastructure(),
    staleTime: Infinity, // Manual refresh only
    meta: { manualRefresh: true }, // expensive: a write elsewhere must not refetch it
  });
}

export function useAdminRefreshInfrastructure() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => adminRefreshInfrastructure(),
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY, data);
    },
  });
}
